const angular = require('angular');
const app = angular.module('learn-services');

app.factory('Navigation', ['Access', 'appConfiguration', '$location', '$window', '$routeParams', 'Storage', function(Access, appConfiguration, $location, $window, $routeParams, Storage) {
    var self = this;
    const publicRoutes = ['/signin', '/forgot', '/resetpassword', '/invitecode', '/accept', '/register-with-userid', '/reset', '/saml-transition', '/saml-transition-error', '/register', '/oauth-transition', '/please-wait-transferring-public'];
    /**
     * Navigation control object
     */
    self.navigation = {
      goToHome: function() {
        // empty object clears the query - (helpful from preauth routes)
        let token = Access.getAuthtoken();
        
        if (token && token.company && token.company.landing === 'dashboard') {
          return self.navigation.goTo('/dashboard/activity', {});
        }
        self.navigation.goTo('/explore', {});
      },
      goToSignIn: function(ignore) {
        var preRedirect = self.navigation.getPath();
        var redirectParams = self.navigation.getUrlParameters();
        if (preRedirect === '/resetpassword') {
          return;
        }
        if (!ignore && preRedirect && self.navigation.isRouteSecure(preRedirect) && preRedirect !== '/explore') {
          Storage.put('preRedirect', preRedirect);
          if (redirectParams) {
            Storage.put('redirectParams', redirectParams);
          }
        }
        self.navigation.goTo('/signin');
      },
      goTo: function(path, qparams) {
        if (qparams !== undefined) {
          $location.path(path).search(qparams);
        } else {
          $location.path(path);
        }
      },
      goToTab: function(path, qparams) {
        $window.open('#' + path, '_blank');
        $window.scrollTo(0, 0);
      },
      isRouteSecure: function(route) {
        var path = route || $location.path();
        return publicRoutes.indexOf(path) === -1;
      },
      getUrl: function() {
        return $location.absUrl();
      },
      getHost: function() {
        return appConfiguration.host;
      },
      getUrlParameters: function() {
        return $location.search();
      },
      getRouteParameters: function() {
        return $routeParams;
      },
      getPath: function() {
        return $location.path();
      },
      getHash: function() {
        return $location.hash();
      },
      isRoute: function(route) {
        return $location.path() === route;
      },
      isInRoute: function(route) {
        return new RegExp(route).test($location.path());
      },
      clearUrlParameters: function() {
        $location.url($location.path());
      },
      history: [],
      historyLocation: null,
      back: function(selected) {
        var item;
        var location;
        var history = self.navigation.history;
        var historyLocation = self.navigation.historyLocation;
        if (history.length === 1) {
          self.navigation.goTo('/explore');
          return;
        }
        if (historyLocation === null) {
          location = history.length - 2;
        }
        if (typeof historyLocation === 'number') {
          location = history[historyLocation];
        }
        if (typeof selected === 'number' && history[selected]) {
          location = selected;
        }
        item = history[location];
        item = item.split('continu.co/#');
        if (item.length !== 2) {
          item = history[location];
          item = item.split('continu.co/pvt/#');
          if (item.length !== 2) {
            return;
          }
        }
        // change history to one before the item to navigate too (it will be added back on when navigated)
        self.navigation.history = self.navigation.history.slice(0, location);
        self.navigationHistory = location;
        self.navigation.goTo(item[1]);
      }
    };
    return self.navigation;
  }]);